import importerReducers from 'src/modules/shared/importer/importerReducers';
import actions from 'src/modules/interaction/importer/interactionImporterActions';

export default importerReducers(actions);
